export const en = {
  ['%=']: 'Remainder assignment',
  ['&=']: 'Bitwise AND assignment',
  ['**=']: 'Exponentiation assignment',
  ['()=>{}']: 'Create arrow function',
  ['*=']: 'Multiplication assignment',
  ['+=']: 'Addition assignment',
  ['-=']: 'Subtraction assignment',
  ['/=']: 'Division assignment',
  [':']: 'otherwise,',
  ['<<=']: 'Left shift assignment',
  ['=']: 'Assignment',
  ['>>=']: 'Right shift assignment',
  ['>>>=']: 'Unsigned right shift assignment',
  ['?']: 'is truly,',
  ['^=']: 'Bitwise XOR assignment',
  ['as']: 'named as',
  assignmentPattern: '省略時は',
  ['class{}']: 'Create class',
  const: 'Declare',
  continue: 'Skip this loop',
  debugger: 'Launch debugger',
  ['do while']: 'Loop while truly',
  extends: 'Inherit another class',
  false: 'False',
  ['function(){}']: 'Create function',
  idEnd: '"',
  idStart: '"',
  init: 'is',
  let: 'Declare',
  null: 'null',
  object: 'object',
  true: 'true',
  undefined: 'undefined',
  var: 'Declare',
  while: 'Loop while',
  ['|=']: 'Bitwise OR assignment'
};
